import { e as ne, h as le, i as N, j as oe, c as ue, d as ve, g as pe } from "./helpers-CA92ST8-.js";
import { useRef as de } from "react";
import he from "../../../core/dist/module/hooks/useInput.js";
import B from "../../../core/dist/module/errors/SyntheticChangeError.js";
var D = function(p) {
  return function() {
    for (var j = arguments.length, d = new Array(j), h = 0; h < j; h++) d[h] = arguments[h];
    return new p("".concat(d.join(`

`), `
`));
  };
};
function ye() {
  var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = p.mask, d = j === void 0 ? "" : j, h = p.replacement, I = h === void 0 ? {} : h, F = p.showMask, M = F !== void 0 && F, H = p.separate, q = H !== void 0 && H, G = p.track, J = p.modify, se = p.onMask, R = typeof I == "string" ? ne(I) : I, e = de(null);
  return he({ init: function(i) {
    var E = i.controlled, a = i.initialValue;
    process.env.NODE_ENV !== "production" && function(t) {
      var l = t.initialValue, k = t.mask, n = t.replacement;
      l.length > k.length && console.error(D(Error)("The initialized value of the `value` or `defaultValue` property is longer than the value specified in the `mask` property. Check the correctness of the initialized value in the specified property.", 'Invalid value: "'.concat(l, '".')));
      var C = Object.keys(n).filter(function(g) {
        return g.length > 1;
      });
      C.length > 0 && console.error(D(Error)("Object keys in the `replacement` property are longer than one character. Replacement keys must be one character long. Check the correctness of the value in the specified property.", "Invalid keys: ".concat(C.join(", "), ".")));
      for (var c = k.slice(0, l.length), s = -1, r = 0; r < c.length; r++) {
        var z = Object.prototype.hasOwnProperty.call(n, c[r]);
        if (!(c[r] === l[r] || z && n[c[r]].test(l[r]))) {
          s = r;
          break;
        }
      }
      s !== -1 && console.error(D(Error)("An invalid character was found in the initialized property value `value` or `defaultValue` (index: ".concat(s, "). Check the correctness of the initialized value in the specified property."), 'Invalid value: "'.concat(l, '".')));
    }({ initialValue: a, mask: d, replacement: R }), a = E || a ? a : M ? d : "";
    var m = { mask: d, replacement: R, showMask: M, separate: q };
    return e.current = { value: a, props: m, fallbackProps: m }, { value: a };
  }, tracking: function(i) {
    var E, a = i.inputType, m = i.previousValue, t = i.addedValue, l = i.changeStart, k = i.changeEnd;
    if (e.current === null) throw new B("The state has not been initialized.");
    e.current.value !== m ? e.current.props = e.current.fallbackProps : e.current.fallbackProps = e.current.props;
    var n = le(m, { end: l, mask: e.current.props.mask, replacement: e.current.props.replacement, separate: e.current.props.separate }), C = RegExp("[^".concat(Object.keys(e.current.props.replacement).join(""), "]"), "g"), c = e.current.props.mask.replace(C, "");
    n && (n = N(n, { replacementChars: c, replacement: e.current.props.replacement, separate: e.current.props.separate }));
    var s = G == null ? void 0 : G(oe(oe({}, a === "insert" ? { inputType: a, data: t } : { inputType: a, data: null }), {}, { value: m, selectionStart: l, selectionEnd: k }));
    if (s === !1) throw new B("Custom trekking stop.");
    if (s === null ? t = "" : s !== !0 && s !== void 0 && (t = s), t && (t = N(t, { replacementChars: c.slice(n.length), replacement: e.current.props.replacement, separate: !1 })), a === "insert" && t === "") throw new B("The character does not match the key value of the `replacement` object.");
    var r = le(m, { start: k, mask: e.current.props.mask, replacement: e.current.props.replacement, separate: e.current.props.separate });
    if (e.current.props.separate) {
      var z = e.current.props.mask.slice(l, k).replace(C, ""), g = z.length - t.length;
      g < 0 ? r = r.slice(-g) : g > 0 && (r = z.slice(-g) + r);
    }
    r && (r = N(r, { replacementChars: c.slice(n.length + t.length), replacement: e.current.props.replacement, separate: e.current.props.separate }));
    var K = n + t + r, P = (E = J == null ? void 0 : J(K)) !== null && E !== void 0 ? E : {}, L = P.mask, Q = L === void 0 ? d : L, U = P.replacement, y = U === void 0 ? R : U, W = P.showMask, X = W === void 0 ? M : W, Y = P.separate, Z = Y === void 0 ? q : Y;
    typeof y == "string" && (y = ne(y));
    var T = function(o, f) {
      var u = f.mask, v = f.replacement, O = f.showMask, w = ue(o, { mask: u, replacement: v, showMask: O }), $ = ve(w, { mask: u, replacement: v }), x = pe({ mask: u, replacement: v }), S = pe({ mask: u, replacement: v }, !0);
      return { value: w, input: o, parts: $, pattern: x, isValid: RegExp(S).test(w) };
    }(K, { mask: Q, replacement: y, showMask: X }), ee = function(o) {
      var f, u, v, O = o.inputType, w = o.value, $ = o.addedValue, x = o.beforeChangeValue, S = o.parts, ie = o.replacement, ce = o.separate, _ = S.filter(function(A) {
        var ae = A.type;
        return ae === "input" || ce && ae === "replacement";
      }), re = (f = _[x.length + $.length - 1]) === null || f === void 0 ? void 0 : f.index, b = (u = _[x.length - 1]) === null || u === void 0 ? void 0 : u.index, V = (v = _[x.length + $.length]) === null || v === void 0 ? void 0 : v.index;
      if (O === "insert") {
        if (re !== void 0) return re + 1;
        if (V !== void 0) return V;
        if (b !== void 0) return b + 1;
      }
      if (O === "deleteForward") {
        if (V !== void 0) return V;
        if (b !== void 0) return b + 1;
      }
      if (O === "deleteBackward") {
        if (b !== void 0) return b + 1;
        if (V !== void 0) return V;
      }
      var te = w.split("").findIndex(function(A) {
        return Object.prototype.hasOwnProperty.call(ie, A);
      });
      return te !== -1 ? te : w.length;
    }({ inputType: a, value: T.value, addedValue: t, beforeChangeValue: n, parts: T.parts, replacement: y, separate: Z });
    return e.current.value = T.value, e.current.props = { mask: Q, replacement: y, showMask: X, separate: Z }, { value: T.value, selectionStart: ee, selectionEnd: ee, __detail: T };
  }, eventType: "input-mask", eventHandler: se });
}
export {
  ye as default
};
//# sourceMappingURL=useMask.js.map
